<template>
    <v-input :hide-details="hideDetails">
        <div class="motonet-checkbox d-flex gc-3 align-center" @click.stop="toggle" v-bind="{'class': cssClass}"
             :class="color ? color : 'text-grey-darken-1'">
            <div class="position-relative d-inline-flex">
                <input :id="id" type="checkbox" :checked="checked" class="el-checkbox"/>
                <v-icon :icon="mdiCheck" color="white" :size="18" class="check-icon" v-if="checked"></v-icon>
            </div>
            <div class="text-body-2" :class="[weight ? weight : 'font-weight-bold', flex ? 'd-flex justify-space-between ga-2' : '']">
                <slot>{{ label }}</slot>
                <span v-if="required" class="ml-1 font-weight-bold text-red">*</span></div>
        </div>
    </v-input>
</template>
<script setup>
import {computed, useId} from "vue";
import {mdiCheck} from "@mdi/js";
import {isNumber} from "lodash-es";

const props = defineProps({
    label: String,
    value: {
        type: [String, Boolean, Number],
        required: false,
        default: true
    },
    required: Boolean,
    falseValue: [String, Number, Object],
    trueValue: [String, Number, Object],
    id: [String, Number],
    color: String,
    weight: String,
    cssClass: String,
    array: Boolean,
    hideDetails: Boolean,
    flex: Boolean,
})
const uid = useId();
const id = computed(() => props.id || `input-${uid}`);
const emit = defineEmits(['update:modelValue'])
const model = defineModel()
const checked = computed(() => {
    if (typeof model.value === 'string') {
        return model.value === props.trueValue;
    }
    if (props.trueValue !== undefined || props.falseValue !== undefined) {
        return model.value === props.trueValue;
    }
    if (typeof model.value === 'object' || Array.isArray(model.value)) {
        return model.value.includes(props.value);
    }
    return model.value === props.value
})
const setModel = (val) => {
    model.value = val;
    emit('update:modelValue', val)
}
const toggle = () => {
    if ((typeof model.value === 'string' && !props.array) || (props.trueValue || props.falseValue)) {
        setModel(checked.value ? props.falseValue:props.trueValue)
        return;
    }
    if (checked.value) {
        if (typeof model.value === 'object' && !isNumber(props.value)) {
            const index = model.value.indexOf(props.value);
            if (index > -1) {
                model.value.splice(index, 1);
            }
            emit('update:modelValue', model.value)
        } else if (typeof model.value === 'object' && isNumber(props.value)) {
            const index = model.value.indexOf(props.value);
            delete model.value[index];
            emit('update:modelValue', model.value)
        } else
            setModel(false)
    } else {
        if (typeof model.value === 'object' || Array.isArray(model.value)) {
            model.value.push(props.value);
            emit('update:modelValue', model.value)
        } else {
            setModel(props.value);
        }
    }

}
</script>
<style scoped lang="scss">
@use '../../../../plugins/vuetify-settings' as *;
@use 'sass:map';
.motonet-checkbox {
    cursor: pointer;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;

    .check-icon {
        position: absolute;
        top: 1px;
        left: 1px;
        transition: opacity .3s ease;
    }

    .el-checkbox {
        color: inherit;
        appearance: none;
        transition: all .3s ease;
        width: 20px;
        min-width: 20px;
        border: 1px solid currentColor;
        height: 20px;
        border-radius: 4px;
        cursor: pointer;

        &:checked {
            border: 1px solid map.get($orange, 'base');
            background-color: map.get($orange, 'base');
            content: 'dsokf';
            color: white;
        }
    }

    &:hover {
        @media (min-width: 768px) {
            .el-checkbox {
                border: 10px solid map.get($grey, 'base');
            }

            .check-icon {
                opacity: 0;
            }
        }
    }
}
</style>
